import { render } from "./LivraisonsCommande.vue?vue&type=template&id=6c3c8593"
import script from "./LivraisonsCommande.vue?vue&type=script&lang=ts"
export * from "./LivraisonsCommande.vue?vue&type=script&lang=ts"
script.render = render

export default script